import * as events from "./event-bus";
import * as store from "./store";
import { notificationInterfaceFn } from "../../../NotificationInterface.js";
import { DEFAULT_POLL_TIME, MINIMUM_POLL_TIME } from "./constants.js";

export const setupPlatformNotifications = () => {
	const {
		notificationConfig: {
			usePlatformNotifications,
			pollingIntervalInSeconds,
		},
	} = store.get("sk-config") || {};
	if (!usePlatformNotifications) {
		console.warn("Platform notifications are not enabled.");
		return;
	}
	notificationInterfaceFn(store);
	initializeNotifications(pollingIntervalInSeconds).initialize();
};

const initializeNotifications = (pollTime) => {
	const {
		MockNotificationService: { get, markAsRead, dismiss },
	} = window;
	const {
		legacyFormattedData: {
			user: { profileId: userId },
			productId,
		},
	} = store.get("passport-data");

	async function fetchNotifications() {
		try {
			const response = await get(userId, productId.toLowerCase());
			store.set("platform-notifications", response);
			console.log('Notifications Fetched at:', new Date().toLocaleString());
		} catch (error) {
			console.error("Failed to fetch notifications:", error);
		}
	}

	async function handleNotificationAction(notification, action, eventName) {
		if (!notification?.id) return;

		try {
			await action(notification.id);
			await fetchNotifications();
			events.emit(eventName, notification);
		} catch (error) {
			console.error(`Failed to ${eventName}:`, error);
		}
	}
    
	
	const notificationActions = {
		read: async (notification) =>
			handleNotificationAction(
				notification,
				markAsRead,
				"notification.read"
			),

		remove: async (notification) =>
			handleNotificationAction(
				notification,
				dismiss,
				"notification.removed"
			),
	};

	function startPolling() {
		fetchNotifications();
		const interval = pollTime >= MINIMUM_POLL_TIME ? pollTime : DEFAULT_POLL_TIME; // Ensure minimum interval of 30 seconds
		setTimeout(startPolling, interval);
	}

	function initialize() {
		events.on("notification.delete", notificationActions.remove);
		events.on("notification.mark-as-read", notificationActions.read);
		startPolling();
	}

	return {
		initialize,
	};
};
